import {ErrorBoundary} from '../../../components/error-boundary';
import React from 'react';
import {withTranslationsAsProps} from '../../../components/translations';

export function TranslatedErrorBoundary({children, message, title}) {
    return (
        <React.Fragment>
            <ErrorBoundary
                errorMessage={message}
                errorTitle={title}
            >
                {children}
            </ErrorBoundary>
        </React.Fragment>
    );
}

export default withTranslationsAsProps({
    'th.inbox.error.message': 'message',
    'th.inbox.error.title': 'title'
})(TranslatedErrorBoundary);


// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/error-boundary.js